import React, { useState } from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import WorkoutDays from "./WorkoutDays";

const WorkoutDaysTab = ({
  exerciseDays,
  userInfoData,
  setExerciseDays,
  formErrors,
  setIsSubmit,
  isViewOnly,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const IS_LENGHT = exerciseDays?.length > 0;

  const handleTabSelect = (index) => {
    setSelectedTab(index);
  };

  return (
    <div className={`workout-days-tab-container`}>
      <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
        {/* <TabList>
          {IS_LENGHT &&
            exerciseDays.map((day, index) => (
              <Tab key={index}>Day {index + 1}</Tab>
            ))}
        </TabList> */}
        <TabList>
          {IS_LENGHT &&
            exerciseDays.map((day, index) => {
              const hasError =
                formErrors?.exerciseDays?.[index] !== null &&
                typeof formErrors?.exerciseDays?.[index] === "object";

              return (
                <Tab
                  key={index}
                  className={`react-tabs__tab ${
                    hasError ? "tab-with-error" : ""
                  }`}
                >
                  Day {index + 1}
                </Tab>
              );
            })}
        </TabList>

        <div className="grayLine"></div>

        {exerciseDays.map((day, index) => (
          <TabPanel key={index}>
            {IS_LENGHT && selectedTab === index && (
              <WorkoutDays
                userInfoData={userInfoData}
                exerciseDays={[day]}
                setExerciseDays={setExerciseDays}
                formErrors={formErrors}
                setIsSubmit={setIsSubmit}
                dayIndex={index}
                exerciseDaysArray={exerciseDays}
                isViewOnly={isViewOnly}
              />
            )}
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default WorkoutDaysTab;
